import { useLocation } from 'react-router-dom'
import { GET_STARTED_URL } from '../../_data/marketingLinks'
import {
  CtaButton,
  LogoLink,
  LogoMark,
  Nav,
  NavInner,
  NavLink,
  NavLinks,
} from './styled'

const MarketingNav = (): JSX.Element => {
  const location = useLocation()
  const isOnFeatures = location.pathname === '/features'
  const isOnUseCases = location.pathname === '/use-cases'
  return (
    <Nav>
      <NavInner>
        <LogoLink to="/">
          <LogoMark aria-hidden="true">Qc</LogoMark>
          QuickCal
        </LogoLink>
        <NavLinks>
          <NavLink to="/features" data-active={isOnFeatures}>
            Features
          </NavLink>
          <NavLink to="/use-cases" data-active={isOnUseCases}>
            Use cases
          </NavLink>
        </NavLinks>
        <CtaButton href={GET_STARTED_URL}>Get started</CtaButton>
      </NavInner>
    </Nav>
  )
}

export default MarketingNav
